import { API_URL, pyApiURL } from "../../../utils/constant";
import { APIError, handleAPIError } from "../../common/errorHandler";
import { getDecoratedUrl } from "../../common/urlService";
import { getApiAsyn, getApiAsynWithBase } from "../../PostAPI";

export const getDashBoardAllReservation = async (payload) => {
  const url = getDecoratedUrl({
    url: API_URL.DASHBOARD.ALL_RESERVATIONS,
    payload,
  });

  try {
    const result = await getApiAsyn(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }

    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const getDashBoardDetails = async () => {
  const url = API_URL.DASHBOARD.FETCH_DASHBOARD_DETAILS;
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const getV4Dashboard = async (locationIds = []) => {
  let url = API_URL.DASHBOARD.V4_DASHBOARD;
  if (locationIds.length > 0) {
    url += `?locationIds=${locationIds.join(",")}`;
  }
  try {
    const result = await getApiAsynWithBase(url, localStorage.getItem("token"));
    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const getQuickSearches = async () => {
  try {
    const result = await getApiAsynWithBase(
      API_URL.DASHBOARD.QUICK_SEARCHES,
      localStorage.getItem("token")
    );
    if (result?.error) throw new APIError(result);
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const saveQuickSearch = async (name, locationIds) => {
  const url = pyApiURL + API_URL.DASHBOARD.QUICK_SEARCHES;
  try {
    const response = await fetch(url, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      method: "POST",
      body: JSON.stringify({ name, locationIds }),
    });
    if (response.status === 401) {
      localStorage.clear();
      window.location.replace("/");
    }
    const data = await response.json();
    data["APIResult"] = 1;
    return data;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const deleteQuickSearch = async (id) => {
  const url = pyApiURL + API_URL.DASHBOARD.QUICK_SEARCHES + "/" + id;
  try {
    const response = await fetch(url, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      method: "DELETE",
    });
    if (response.status === 401) {
      localStorage.clear();
      window.location.replace("/");
    }
    const data = await response.json();
    data["APIResult"] = 1;
    return data;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};
